import { parseISO } from 'date-fns';

export const AFTER_PARTY_WINDOW_HOURS = 48;

const MS_PER_HOUR = 60 * 60 * 1000;

export type PartyWindow = {
	startTime: string;
	endTime: string;
};

export type PartyBranch = 'inactive' | 'unclaimed' | 'claimed';

export function isPartyActive(party: PartyWindow, now: Date): boolean {
	const nowMs = now.getTime();
	return (
		nowMs > parseISO(party.startTime).getTime() &&
		nowMs < parseISO(party.endTime).getTime()
	);
}

/**
 * Inclusive at exactly 48 hours after `endTime`, matching the KMP predicate
 * `endTime - now >= -AFTER_PARTY_THRESHOLD` (REQ-FLOW-AFTER-WINDOW).
 */
export function isWithinAfterPartyWindow(party: PartyWindow, now: Date): boolean {
	const windowEndMs =
		parseISO(party.endTime).getTime() + AFTER_PARTY_WINDOW_HOURS * MS_PER_HOUR;
	return now.getTime() <= windowEndMs;
}

/**
 * `isClaimed` is supplied by the caller. The tab-scoped claimed key that feeds it
 * is owned by WEB-SP-CLAIM (REQ-CLAIM-PERSIST), not by this helper.
 */
export function selectPartyBranch(
	party: PartyWindow,
	now: Date,
	isClaimed: boolean
): PartyBranch {
	if (!isPartyActive(party, now)) {
		return 'inactive';
	}
	return isClaimed ? 'claimed' : 'unclaimed';
}
